/**
 * @file 修改密码
 * @author fuqiang15(fuqiang15@baidu.com)
 */

import FormModel from '@baidu/ve-ria/views/FormModel';
import {omit} from 'lodash';

export default class PasswordFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    formData = {
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: ''
    };

    init() {
        super.init();

        this.updateRequester = this.api.passwordUpdate;
    }

    prepareData(data) {
        return omit(data, 'newPasswordAgain');
    }
}
